var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-trans-details" },
    [
      _c(
        "div",
        { staticClass: "filter-section-container" },
        [
          _c("div", { staticClass: "filter-fixed" }, [
            _c("span", { staticClass: "filter-fixed-title" }, [
              _vm._v(_vm._s(_vm.$t("data.filter_section"))),
            ]),
            _c("i", {
              staticClass: "el-icon-arrow-down filter-fixed-arrow",
              class: { "fiter-icon-arrow-route": !_vm.showFilterContent },
              on: { click: _vm.onClickFixedArrow },
            }),
          ]),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilterContent,
                    expression: "showFilterContent",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "times", $$v)
                            },
                            expression: "search.times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("merchantAccount.complete_time")) +
                              " "
                          ),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            size: "small",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                            "picker-options": !_vm.$store.getters.isPii
                              ? _vm.$commonFn.dateLimit(this, 31)
                              : undefined,
                          },
                          model: {
                            value: _vm.search.response_times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "response_times", $$v)
                            },
                            expression: "search.response_times",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.$store.getters.isID
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("data.actual_settlement_time")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("el-date-picker", {
                              staticClass: "filter-item-value",
                              attrs: {
                                size: "small",
                                format: "yyyy-MM-dd",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                type: "daterange",
                                "range-separator": "~",
                                "start-placeholder": _vm.$t(
                                  "components.start_date"
                                ),
                                "end-placeholder": _vm.$t(
                                  "components.end_date"
                                ),
                                "default-time": ["00:00:00", "23:59:59"],
                              },
                              model: {
                                value: _vm.search.settlement_time,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "settlement_time", $$v)
                                },
                                expression: "search.settlement_time",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchant.payment_channel"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: {
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.search.channel_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "channel_code", $$v)
                              },
                              expression: "search.channel_code",
                            },
                          },
                          _vm._l(
                            _vm.compFilterPaymentChannel,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.channel_code,
                                  value: item.channel_code,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.$store.getters.isAllCountry
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("data.transaction_currency"))
                              ),
                            ]),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item-value",
                                attrs: { size: "small", clearable: "" },
                                on: { change: _vm.onCurrencyChange },
                                model: {
                                  value: _vm.search.currency,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.search, "currency", $$v)
                                  },
                                  expression: "search.currency",
                                },
                              },
                              _vm._l(
                                _vm.$store.state.page.countryArr,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.currency,
                                      value: item.currency,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("merchantAccount.transaction_status"))
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { size: "small", clearable: "" },
                            model: {
                              value: _vm.search.transaction_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "transaction_status", $$v)
                              },
                              expression: "search.transaction_status",
                            },
                          },
                          _vm._l(
                            _vm.payTransactionStatusArr,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.settlement_status"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { size: "small", clearable: "" },
                            model: {
                              value: _vm.search.settlement_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "settlement_status", $$v)
                              },
                              expression: "search.settlement_status",
                            },
                          },
                          _vm._l(
                            _vm.transactionSettlementStatusMap,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.transaction_id"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { size: "small", type: "text", clearable: "" },
                          model: {
                            value: _vm.search.transaction_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "transaction_id", $$v)
                            },
                            expression: "search.transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.merchant_order_id"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { size: "small", type: "text", clearable: "" },
                          model: {
                            value: _vm.search.merchant_order_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "merchant_order_id", $$v)
                            },
                            expression: "search.merchant_order_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.reference_no"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { size: "small", type: "text", clearable: "" },
                          model: {
                            value: _vm.search.channel_reference_no,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "channel_reference_no", $$v)
                            },
                            expression: "search.channel_reference_no",
                          },
                        }),
                      ],
                      1
                    ),
                    !_vm.$store.getters.isID
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("checkout.checkout_order_id"))
                              ),
                            ]),
                            _c("el-input", {
                              staticClass: "filter-item-value",
                              attrs: {
                                size: "small",
                                type: "text",
                                clearable: "",
                              },
                              model: {
                                value: _vm.search.checkout_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "checkout_id", $$v)
                                },
                                expression: "search.checkout_id",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.getters.isPii
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("acceptPayments.static_qr_id"))
                              ),
                            ]),
                            _c("el-input", {
                              staticClass: "filter-item-value",
                              attrs: {
                                size: "small",
                                type: "text",
                                clearable: "",
                              },
                              model: {
                                value: _vm.search.qr_stand_no,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "qr_stand_no", $$v)
                                },
                                expression: "search.qr_stand_no",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.getters.isPii
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(_vm._s(_vm.$t("operation.business"))),
                            ]),
                            _c("ScopeSelect", {
                              staticClass: "filter-item-value",
                              attrs: {
                                value: _vm.search.business_id,
                                "is-remote": true,
                                "http-request-method":
                                  _vm.searchBusinessOptions,
                                "remote-params": _vm.getBusinessSearchParams,
                                "option-label": _vm.formatBusinessOption,
                                "select-placeholder": _vm.$t(
                                  "operation.select_business"
                                ),
                              },
                              on: {
                                updateValue: function ($event) {
                                  _vm.search.business_id = $event
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.getters.isPii
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(_vm._s(_vm.$t("operation.franchisee"))),
                            ]),
                            _c("ScopeSelect", {
                              staticClass: "filter-item-value",
                              attrs: {
                                value: _vm.search.franchisee_id,
                                "is-remote": true,
                                "http-request-method":
                                  _vm.searchFranchiseeOptions,
                                "remote-params": _vm.getFranchiseeSearchParams,
                                "option-label": _vm.formatFranchiseeOption,
                                "select-placeholder": _vm.$t(
                                  "operation.select_franchisee"
                                ),
                              },
                              on: {
                                updateValue: function ($event) {
                                  _vm.search.franchisee_id = $event
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.getters.isPii
                      ? _c("div", { staticClass: "filter-item" }, [
                          _c("div", { staticClass: "filter-item-label" }),
                        ])
                      : _vm._e(),
                    _vm.$store.getters.isID && _vm.compIsJTMerchant
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("merchant.jt_institute_way_code")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item-value",
                                attrs: {
                                  filterable: "",
                                  size: "small",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.search.jt_institute_way_code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.search,
                                      "jt_institute_way_code",
                                      $$v
                                    )
                                  },
                                  expression: "search.jt_institute_way_code",
                                },
                              },
                              _vm._l(
                                _vm.jtInstituteWayCode,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.getters.isMX
                      ? _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("div", { staticClass: "filter-item-label" }, [
                              _vm._v(_vm._s(_vm.$t("data.pos_machine_sn"))),
                            ]),
                            _c("el-input", {
                              staticClass: "filter-item-value",
                              attrs: {
                                size: "small",
                                type: "text",
                                clearable: "",
                              },
                              model: {
                                value: _vm.search.pay_data,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "pay_data", $$v)
                                },
                                expression: "search.pay_data",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c(
                    "div",
                    { staticClass: "filter-operate-left" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mb-10 download-btn",
                          attrs: {
                            loading: _vm.downloading,
                            type: "info",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.onClickDowmloadBtn },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.download")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { size: "small" },
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      !_vm.$store.getters.isAllCountry
        ? _c("div", { staticClass: "total-container" }, [
            _c("div", { staticClass: "total-item" }, [
              _vm._v(_vm._s(_vm.$t("data.total_count")) + ": "),
              _c("span", { staticStyle: { color: "#3855F1" } }, [
                _vm._v(_vm._s(_vm.total_count)),
              ]),
            ]),
            _c("div", { staticClass: "total-item" }, [
              _vm._v(_vm._s(_vm.$t("data.total_amount")) + ": "),
              _c("span", { staticStyle: { color: "#3855F1" } }, [
                _vm._v(
                  _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(_vm._f("toDivideWithDot")(_vm.total_amount))
                ),
              ]),
            ]),
            _c("div", { staticClass: "total-item" }, [
              _vm._v(_vm._s(_vm.$t("data.total_fee")) + ": "),
              _c("span", { staticStyle: { color: "#3855F1" } }, [
                _vm._v(
                  _vm._s(_vm.$store.getters.currency) +
                    " " +
                    _vm._s(_vm._f("toDivideWithDot")(_vm.total_fee))
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.transaction_id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.merchant_order_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.merchant_order_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.reference_no"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.channel_reference_no)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.payment_type"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getproductCategoryMap(
                                scope.row.product_category
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchant.payment_channel"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.channel_code))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.transaction_status"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getPayTransStatusType(
                                scope.row.transaction_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getPayTransStatusLabel(
                                  scope.row.transaction_status
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.$store.getters.isMX
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("data.pos_machine_sn"),
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.pay_data))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      402380257
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.transaction_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.transaction_amount
                              )
                            ) +
                              " " +
                              _vm._s(scope.row.source_currency)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.$store.getters.isAllCountry
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("data.exchange_rate"),
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.source_currency ===
                                      scope.row.destination_currency
                                      ? "-"
                                      : scope.row.mch_rate
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4128400873
                    ),
                  })
                : _vm._e(),
              _vm.$store.getters.isAllCountry
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("merchantAccount.settlement_amount"),
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      scope.row.destination_amount
                                    )
                                  ) +
                                    " " +
                                    _vm._s(scope.row.destination_currency)
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      351390412
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchant.service_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(scope.row.fee_split)
                            ) +
                              " " +
                              _vm._s(scope.row.fee_split_currency)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "105",
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.transaction_create_time) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "105",
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_return_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.$store.getters.isID && _vm.compIsJTMerchant
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("merchant.jt_institute_way_code"),
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.institute_way_code)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1008145149
                    ),
                  })
                : _vm._e(),
              _vm.$store.getters.isPii
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("operation.business"),
                      "min-width": "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "copyable-no",
                                  on: {
                                    click: function ($event) {
                                      _vm.copyNumber(
                                        _vm.getBusinessNo(scope.row)
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.getBusinessNo(scope.row)))]
                              ),
                              _c("div", { staticClass: "secondary-text" }, [
                                _vm._v(_vm._s(_vm.getBusinessName(scope.row))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3612735338
                    ),
                  })
                : _vm._e(),
              _vm.$store.getters.isPii
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("operation.franchisee"),
                      "min-width": "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "copyable-no",
                                  on: {
                                    click: function ($event) {
                                      _vm.copyNumber(
                                        _vm.getFranchiseeNo(scope.row)
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.getFranchiseeNo(scope.row)))]
                              ),
                              _c("div", { staticClass: "secondary-text" }, [
                                _vm._v(
                                  _vm._s(_vm.getFranchiseeName(scope.row))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3222564390
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("data.remark"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.remark || scope.row.remark.length <= 10
                          ? _c("span", [_vm._v(_vm._s(scope.row.remark))])
                          : _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  content: scope.row.remark,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "show-ellipsis",
                                    staticStyle: {
                                      cursor: "pointer",
                                      display: "inline-block",
                                      "max-width": "100px",
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.remark))]
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailTxt(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.store.getters.authorities.includes(
                          "AUTH_CODE_PAYMENT_REFUND"
                        )
                          ? _c(
                              "el-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    [1, 4, 5, 6, 8, 9].includes(
                                      scope.row.refund_not_support_reason
                                    )
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tips.refund_tip_1")
                                              ) +
                                              " "
                                          ),
                                          _c("br"),
                                        ])
                                      : [2, 3].includes(
                                          scope.row.refund_not_support_reason
                                        )
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tips.refund_tip_2")
                                              )
                                          ),
                                          _c("br"),
                                        ])
                                      : [7].includes(
                                          scope.row.refund_not_support_reason
                                        )
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tips.refund_tip_3")
                                              )
                                          ),
                                          _c("br"),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("components.refund")
                                              )
                                          ),
                                          _c("br"),
                                        ]),
                                  ]
                                ),
                                _c("svg-icon", {
                                  class: {
                                    "is-disabled": !(
                                      scope.row.original_refund_status &&
                                      scope.row.original_refund_status !== 1
                                    ),
                                  },
                                  attrs: {
                                    "class-name": "icon-function",
                                    "icon-class": "refund-icon",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onClickRefundTxt(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("payment-details-modal", {
        ref: "paymentDetailsModal",
        attrs: { "detail-id": _vm.detailId },
      }),
      _c("payment-refund-modal", {
        ref: "paymentRefundModal",
        attrs: { "detail-id": _vm.detailId },
        on: { updatelist: _vm.handleFilter },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }